export const getCarriers = (state) => state.carrierList;
export const getGivenConsents = (state) => state.carrierList.givenConsents;
